import { memo } from 'react';
import styled from 'styled-components';
import moment from 'moment';

const StyledCopyrightsText = styled.p`
  font-size: 13px;
  font-weight: normal;
  margin: 0px;
  padding: 0px;
  color: #000000;
`;

const Copyrights = memo(({ appName }) => (
  <StyledCopyrightsText>
    Copyrights ©  KAROLS WEB SOLUTION PRIVATE LIMITED 2026.All Rights Reserved.
  </StyledCopyrightsText>
));

export default Copyrights;
